import { Icon, IconProps } from './Icon';

export const TypeIcon = ({ ...props }: IconProps) => (
  <Icon
    {...props}
    viewBox="0 0 20 20"
  >
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 17.5V14.1667M10 10.8333V7.5M10 4.16667V2.5M8.33333 17.5H11.6667M6.66666 4.16667V7.5H15.8333L17.5 5.83333L15.8333 4.16667H6.66666ZM11.6667 10.8333V14.1667H4.99999L3.33333 12.5L4.99999 10.8333H11.6667Z"
        stroke="#5E6A81"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Icon>
);
